/*
  Necklace builder designs in the cart (sections/pz-builder.liquid), 2026-10-02.

  A design is several cart lines: the chain and one line per charm, tied together by the "_Design ID" property.
  They only make sense together, so the cart treats them as one piece: "Remove" or a new quantity on any line of a
  design is applied to all of its lines. snippets/line-item.liquid marks those lines with [data-pz-design]; charm
  lines carry no controls of their own (custom-overrides.css, section 40).

  The theme's own handler (theme.js, LineItemQuantity) listens on <line-item-quantity>; this one runs first, in the
  capture phase, and only for lines of a design. Every other line is left to the theme.
*/
(() => {
  const kok = () => window.Shopify?.routes?.root || '/';
  const tasarim = (el) => el.closest('line-item, tr')?.querySelector('[data-pz-design]')?.dataset.pzDesign;

  async function uygula(kimlik, adet) {
    document.documentElement.dispatchEvent(new CustomEvent('theme:loading:start', { bubbles: true }));
    try {
      const sepet = await (await fetch(`${kok()}cart.js`)).json();
      const updates = {};
      for (const s of sepet.items) if (s.properties?.['_Design ID'] === kimlik) updates[s.key] = adet;
      const bolumler = [];
      document.documentElement.dispatchEvent(new CustomEvent('cart:prepare-bundled-sections', { bubbles: true, detail: { sections: bolumler } }));
      const yanit = await fetch(`${kok()}cart/update.js`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ updates, sections: bolumler.join(',') }),
      });
      if (!yanit.ok) throw new Error('cart');
      const yeni = await yanit.json();
      if (window.themeVariables?.settings?.pageType === 'cart') { window.location.reload(); return; }
      document.documentElement.dispatchEvent(new CustomEvent('cart:change', { bubbles: true, detail: { baseEvent: 'line-item:change', cart: yeni } }));
    } catch {
      document.dispatchEvent(new CustomEvent('cart:refresh'));
    } finally {
      document.documentElement.dispatchEvent(new CustomEvent('theme:loading:end', { bubbles: true }));
    }
  }

  document.addEventListener('click', (e) => {
    const baglanti = e.target.closest?.('a[href*="/cart/change"]');
    const kimlik = baglanti && tasarim(baglanti);
    if (!kimlik) return;
    e.preventDefault(); e.stopPropagation();
    uygula(kimlik, Math.max(0, parseInt(new URL(baglanti.href).searchParams.get('quantity')) || 0));
  }, true);

  document.addEventListener('change', (e) => {
    const girdi = e.target.closest?.('[data-line-key]');
    const kimlik = girdi && tasarim(girdi);
    if (!kimlik) return;
    e.stopPropagation();
    uygula(kimlik, Math.max(0, parseInt(girdi.value) || 0));
  }, true);
})();
